"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.favorite.add': 'Dodaj do ulubionych',
    'conversations.favorite.remove': 'Usuń z ulubionych',
};
